var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":_vm.modId,"title":_vm.titleMsg,"hide-footer":""}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","block":""},on:{"click":_vm.confirmModal}},[_vm._v(_vm._s(_vm.buttonMsg))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e26ad56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmModal.vue
// module id = null
// module chunks = 